// Power-Bot widget logic, ported unchanged from the Kalles layout except: product context comes from
// window.pcBotProduct (no price for quote products) and the lead form heading uses leadFormTitle.
  (function() {
    'use strict';

    /* =============================================
       הגדרות גלובליות
    ============================================= */
    var API_URL         = "https://shopify-ai-bot-production.up.railway.app/chat";
    var WHATSAPP_NUMBER = "972584222222";
    var STORAGE_KEY     = 'ai_chat_history_v2';
    var SESSION_KEY     = 'ai_session_v1';
    var chatHistory     = [];

    /* מזהה שיחה יציב — השרת דורש sessionId (בלעדיו מחזיר 400) וזוכר לפיו הקשר בין הודעות */
    function getSessionId() {
      try {
        var sid = localStorage.getItem(SESSION_KEY);
        if (!sid) { sid = 'pb-' + Math.random().toString(36).slice(2) + Date.now(); localStorage.setItem(SESSION_KEY, sid); }
        return sid;
      } catch (e) { return 'pb-' + Date.now(); }
    }

    var input      = document.getElementById('ai-main-input');
    var resultsEl  = document.getElementById('ai-results');
    var windowElem = document.getElementById('ai-widget-window');
    var submitBtn  = document.getElementById('ai-submit-btn');
    var videoEl    = document.getElementById('ai-strip-video');
    var isOpen     = false;
    var isSending  = false;
    var lastQuery  = '';

    /* נתוני מוצר נוכחי (אם קיים) */
    var currentPageProduct = null;
    currentPageProduct = window.pcBotProduct || null; // set by snippets/pc-bot.liquid; no price for quote products

    /* =============================================
       אתחול
    ============================================= */
    function init() {
      loadHistory();
      bindEvents();
      lazyLoadVideo();
      /*
        תיקון: מוסיפים margin-top דינמי ל-header הקיים
        של האתר כדי שלא יוסתר מאחורי פס ה-AI.
      */
      adjustHeaderOffset();
    }

    /* =============================================
       תיקון חדש: הזזת ה-header הקיים למטה מהפס
       מחשב את גובה הפס ומוסיף margin-top לאלמנט
       #nt_wrapper שמכיל את כל תוכן האתר.
    ============================================= */
    function adjustHeaderOffset() {
      var strip = document.getElementById('ai-strip-container');
      var wrapper = document.getElementById('nt_wrapper');
      if (!strip || !wrapper) return;

      function applyOffset() {
        var stripH = strip.offsetHeight;
        wrapper.style.marginTop = stripH + 'px';
      }

      applyOffset();
      /* עדכון אם גודל החלון משתנה */
      window.addEventListener('resize', applyOffset);
    }

    /* =============================================
       FIX (ביצועים): הוידאו מופעל רק אחרי טעינת הדף
    ============================================= */
    function lazyLoadVideo() {
      if (!videoEl) return;
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          if (entries[0].isIntersecting) {
            videoEl.play().catch(function() {});
            observer.disconnect();
          }
        });
        observer.observe(videoEl);
      } else {
        videoEl.play().catch(function() {});
      }
    }

    /* =============================================
       אירועים
    ============================================= */
    function bindEvents() {
      input.addEventListener('focus', function() {
        openChat();
      });

      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') sendMsg();
      });

      /* סגור חלון בלחיצה מחוץ לאזור */
      document.addEventListener('click', function(e) {
        var strip = document.getElementById('ai-strip-container');
        if (!windowElem.contains(e.target) && !strip.contains(e.target)) {
          closeChat();
        }
      });

      /* ESC לסגירה */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isOpen) closeChat();
      });
    }

    /* =============================================
       ניהול חלון
    ============================================= */
    /* שאלות מוצעות שמופיעות בפתיחה — מנחות את הלקוח ומגדילות מעורבות */
    var SUGGESTIONS = ['מחשב גיימינג', 'לפטופ לעבודה', 'מסך 27 אינץ׳', 'אל-פסק לשרת'];
    function showGreetingIfEmpty() {
      if (resultsEl.children.length > 0) return;
      var wrap = document.createElement('div');
      wrap.className = 'chat-row chat-bot';
      /* בדף מוצר — פתיחה מודעת-מוצר + צ'יפים לשאול עליו; אחרת ברירת המחדל */
      var greeting, list;
      if (currentPageProduct && currentPageProduct.title) {
        greeting = 'שלום! אני Power-Bot ⚡<br>אני רואה שאתה מסתכל על <b>' + escapeHtml(currentPageProduct.title) + '</b>. אפשר לשאול אותי עליו — או על כל דבר אחר:';
        list = ['האם המוצר הזה מתאים לי?', 'ספר לי עוד על המוצר הזה', 'יש מוצר דומה זול יותר?'];
      } else {
        greeting = 'שלום! אני Power-Bot, יועץ המכירות של Powercon ⚡<br>איך אפשר לעזור? אפשר גם לבחור נושא:';
        list = SUGGESTIONS;
      }
      var chips = list.map(function(s){ return '<button class="ai-chip" type="button">' + escapeHtml(s) + '</button>'; }).join('');
      wrap.innerHTML = greeting + '<div class="ai-chips">' + chips + '</div>';
      resultsEl.appendChild(wrap);
      Array.prototype.forEach.call(wrap.querySelectorAll('.ai-chip'), function(btn){
        btn.addEventListener('click', function(e){ e.stopPropagation(); window.sendMsg(btn.textContent); });
      });
    }

    function openChat() {
      windowElem.classList.add('active');
      isOpen = true;
      showGreetingIfEmpty();
    }

    window.closeChat = function() {
      windowElem.classList.remove('active');
      isOpen = false;
    };

    window.clearHistory = function() {
      if (confirm("האם למחוק את היסטוריית השיחה?")) {
        chatHistory = [];
        try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
        resultsEl.innerHTML = '';
        closeChat();
      }
    };

    /* =============================================
       שליחת הודעה
    ============================================= */
    window.sendMsg = function(retryText) {
      var text = retryText || input.value.trim();
      if (!text || isSending) return;

      openChat();
      clearFollowups();
      lastQuery = text;

      var userMsgObj = { type: 'chat-user', text: text };
      // בונים את ההיסטוריה לשרת לפני שמירת התור הנוכחי, כדי לא לשלוח את ההודעה הנוכחית פעמיים
      var historyForServer = buildServerHistory();
      renderMessage(userMsgObj);
      saveToHistory(userMsgObj);

      input.value = '';
      setSending(true);

      var loadingEl = renderLoading();
      scrollToBottom();

      // a stalled server must not leave the typing dots spinning forever
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function(){ ctrl.abort(); }, 45000) : 0;
      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: ctrl ? ctrl.signal : undefined,
        body: JSON.stringify({
          sessionId: getSessionId(),
          message: text,
          conversationHistory: historyForServer,
          currentProduct: currentPageProduct  /* המוצר שהלקוח נמצא עליו בדף (null אם לא בדף מוצר) */
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function(data) {
        removeEl(loadingEl);
        appendBotAnswer(data, text); // כותב את התשובה תוך כדי תנועה, ואז חושף טבלה/כרטיסים/פולו-אפ
      })
      .catch(function() {
        removeEl(loadingEl);
        renderErrorMessage(text);
      })
      .finally(function() {
        clearTimeout(timer);
        setSending(false);
      });
    };

    /* =============================================
       אבטחה: sanitize HTML מה-API
    ============================================= */
    function sanitizeHtml(html) {
      var clean = html
        .replace(/<script[\s\S]*?<\/script>/gi, '')
        .replace(/on\w+="[^"]*"/gi, '')
        .replace(/javascript:/gi, '');
      return clean;
    }

    /* מאשר רק קישורי http(s) — הקשחת XSS */
    function safeUrl(u) {
      try { var p = new URL(u, window.location.origin); return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#'; }
      catch (e) { return '#'; }
    }

    /* רינדור markdown מינימלי: טבלאות pipe (תשובות השוואה), הדגשה **טקסט**, ושורות.
       כל תוכן התאים/השורות עובר escape, כך שאי אפשר להזריק HTML. */
    function renderMarkdown(text) {
      var lines = String(text || '').split('\n');
      var html = '', inTable = false, firstRow = true;
      function inline(s) { return escapeHtml(s).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>'); }
      for (var i = 0; i < lines.length; i++) {
        var t = lines[i].trim();
        if (t.charAt(0) === '|' && t.charAt(t.length - 1) === '|') {
          var cells = t.slice(1, -1).split('|');
          var isSep = cells.every(function(c){ return /^[-:\s]+$/.test(c); });
          if (isSep) continue;
          if (!inTable) { html += '<table>'; inTable = true; firstRow = true; }
          var tag = firstRow ? 'th' : 'td';
          html += '<tr>' + cells.map(function(c){ return '<' + tag + '>' + inline(c.trim()) + '</' + tag + '>'; }).join('') + '</tr>';
          firstRow = false;
        } else {
          if (inTable) { html += '</table>'; inTable = false; firstRow = true; }
          var bullet = /^[-*•]\s+(.*)$/.exec(t); // "- x" / "* x" list lines
          html += (t === '') ? '<br>' : bullet ? ('• ' + inline(bullet[1]) + '<br>') : (inline(t) + '<br>');
        }
      }
      if (inTable) html += '</table>';
      return html;
    }

    /* כפתור מעבר לנציג בוואטסאפ (בקשות כמות/ליד / requiresHumanAgent) */
    function buildWhatsappHandoff(userText) {
      var msg = "היי, הגעתי מהצ'אט באתר ואשמח לעזרת נציג." + (userText ? "\nפנייתי: " + userText : "");
      var url = "https://wa.me/" + WHATSAPP_NUMBER + "?text=" + encodeURIComponent(msg);
      return '<a class="ai-wa-btn" href="' + url + '" target="_blank" rel="noopener noreferrer">'
           + '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 00-8.6 15L2 22l5.1-1.3A10 10 0 1012 2zm0 18a8 8 0 01-4.1-1.1l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 1112 20zm4.4-6c-.2-.1-1.4-.7-1.6-.8s-.4-.1-.5.1-.6.8-.8 1-.3.2-.5.1a6.5 6.5 0 01-1.9-1.2 7.3 7.3 0 01-1.4-1.7c-.1-.3 0-.4.1-.5l.4-.5.2-.4v-.4l-.8-1.8c-.2-.5-.4-.4-.5-.4h-.5a.9.9 0 00-.7.3A2.8 2.8 0 006 8.9c0 1.6 1.2 3.2 1.4 3.4s2.3 3.6 5.5 4.9c.8.3 1.4.5 1.9.6.8.3 1.5.2 2.1.1.6-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1z"/></svg>'
           + 'שוחח עם נציג בוואטסאפ</a>';
    }

    function buildProductCardHtml(prod) {
      var name    = escapeHtml(decodeEntities(prod.name || prod.title || '')); // catalog titles carry &#174; / &quot;
      var price   = Number(prod.price || 0);
      var rawUrl  = safeUrl(prod.url || '#');
      var url     = escapeHtml(rawUrl);
      var handle  = escapeHtml(extractHandle(rawUrl));
      var inStock = prod.available !== false;
      var badge   = '<div class="pc-badge ' + (inStock ? 'in' : 'out') + '">' + (inStock ? 'במלאי' : 'בדוק זמינות') + '</div>';
      var why     = prod.why_recommended ? '<div class="pc-why">' + escapeHtml(prod.why_recommended) + '</div>' : '';
      return '<div class="product-card" data-handle="' + handle + '">'
        + '<div class="pc-thumb-wrap"><img class="pc-thumb" alt="" loading="lazy"></div>'
        + '<div class="product-info">'
        + '<div class="product-title">' + name + '</div>'
        + '<div class="product-price">' + ((price === 0) ? 'לפי הצעת מחיר' : '₪' + price.toLocaleString('he-IL')) + '</div>'
        + badge + why
        + '</div>'
        + '<a href="' + url + '" class="product-btn" target="_blank" rel="noopener noreferrer">למוצר</a>'
        + '</div>';
    }

    /* מחלץ handle מכתובת המוצר (…/products/<handle>) לצורך שליפת תמונה */
    function extractHandle(u) {
      var m = String(u || '').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : '';
    }

    /* Hebrew handles can arrive already percent-encoded; encoding them again gave %25D7… and a 404 */
    function safeDecode(s) { try { return decodeURIComponent(s); } catch (e) { return s; } }

    /* טוען תמונת מוצר בצד-לקוח מ-/products/<handle>.js (ללא שינוי שרת). נכשל בשקט. */
    function hydrateImages(container) {
      if (!container) return;
      var cards = container.querySelectorAll('.product-card[data-handle]');
      Array.prototype.forEach.call(cards, function(card) {
        var handle = card.getAttribute('data-handle');
        if (!handle) return;
        fetch('/products/' + encodeURIComponent(safeDecode(handle)) + '.js', { credentials: 'omit' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(p){
            if (!p || !p.featured_image) return;
            var wrap = card.querySelector('.pc-thumb-wrap');
            var img  = card.querySelector('.pc-thumb');
            if (wrap && img) { img.src = p.featured_image; img.alt = p.title || ''; wrap.classList.add('loaded'); }
          })
          .catch(function(){});
      });
    }

    /* פולו-אפ מכירתי: הצעות המשך שמושכות מעלה (דגם חזק יותר, אביזרים משלימים, השוואה, הזמנה) —
       לעולם לא "משהו זול יותר". נבחר לפי מספר המוצרים שהוצגו. */
    function buildFollowups(data) {
      var recs = (data.recommendations || []).length;
      if (recs >= 2) return ['תשווה בין האפשרויות', 'יש דגם חזק יותר?', 'אילו אביזרים משלימים?', 'איך מזמינים?'];
      if (recs === 1) return ['יש דגם חזק יותר?', 'אילו אביזרים מתאימים?', 'מה האחריות?', 'איך מזמינים?'];
      return ['תראה לי דגמים מומלצים', 'מה הכי מתאים לצרכים שלי?'];
    }

    function clearFollowups() {
      var old = resultsEl.querySelectorAll('.ai-followups');
      Array.prototype.forEach.call(old, function(el){ if (el.parentNode) el.parentNode.removeChild(el); });
    }

    function renderFollowups(items) {
      clearFollowups();
      if (!items || !items.length) return;
      var row = document.createElement('div');
      row.className = 'ai-followups';
      row.innerHTML = '<span class="ai-fu-label">רוצה להמשיך?</span>'
        + items.map(function(s){ return '<button class="ai-chip" type="button">' + escapeHtml(s) + '</button>'; }).join('');
      resultsEl.appendChild(row);
      Array.prototype.forEach.call(row.querySelectorAll('.ai-chip'), function(btn){
        btn.addEventListener('click', function(e){ e.stopPropagation(); window.sendMsg(btn.textContent); });
      });
      scrollToBottom();
    }

    /* =============================================
       הצגת תשובת הבוט — מיידית (עם ה-fade-in החלק שכבר קיים ב-CSS),
       ואז כרטיסי מוצר, cross-sell, מעבר לנציג, ופולו-אפ מכירתי.
    ============================================= */
    function appendBotAnswer(data, userText) {
      var html = renderMarkdown(data.reply || '');
      (data.recommendations || []).forEach(function(p){ html += buildProductCardHtml(p); });
      if (data.crossSell && data.crossSell.name) {
        html += '<div class="ai-crosssell">💡 ' + escapeHtml(data.crossSell.name)
              + (data.crossSell.reason ? ' — ' + escapeHtml(data.crossSell.reason) : '') + '</div>';
      }
      if (data.requiresHumanAgent) html += buildWhatsappHandoff(userText);

      var botMsgObj = { type: 'chat-bot', html: html, text: data.reply || '' };
      var div = renderMessage(botMsgObj);
      saveToHistory(botMsgObj);
      if (data.requiresHumanAgent) appendLeadForm(div, data.leadFormTitle); // שדה השארת טלפון (בקשות כמות/ליד)
      hydrateImages(div);                    // תמונות מוצר (צד-לקוח)
      renderFollowups(buildFollowups(data)); // פולו-אפ מכירתי
      revealReply(div);
    }

    /* a long reply (cards, lead form) starts at the top of the view so it is read from its first line */
    function revealReply(div) {
      var top = div.getBoundingClientRect().top - resultsEl.getBoundingClientRect().top + resultsEl.scrollTop;
      if (resultsEl.scrollHeight - top > resultsEl.clientHeight) resultsEl.scrollTop = Math.max(0, top - 8);
      else scrollToBottom();
    }

    /* טופס השארת טלפון — נפתח כשהשרת מסמן requiresHumanAgent (בקשת כמות / ליד).
       בשליחה: שולח את הטלפון כהודעה רגילה; השרת מזהה אותו (detectPhone) ושומר ליד
       (data/leads.jsonl + מייל דרך Resend). מונע את בעיית "אין איפה להשאיר פרטים". */
    function appendLeadForm(container, title) {
      var box = document.createElement('div');
      box.className = 'ai-lead';
      box.innerHTML =
        '<div class="ai-lead-title">השאירו טלפון ונחזור אליכם עם הצעה מותאמת 📞</div>' +
        '<div class="ai-lead-row">' +
          '<input type="tel" class="ai-lead-input" placeholder="מספר טלפון" inputmode="tel" maxlength="20" aria-label="מספר טלפון">' +
          '<button class="ai-lead-btn" type="button">שליחה</button>' +
        '</div>' +
        '<p class="ai-lead-err" role="alert" hidden>נא להזין מספר טלפון מלא (9 ספרות לפחות)</p>';
      if (title) box.querySelector('.ai-lead-title').textContent = title; // server-chosen heading (BOTAI leadFormTitle)
      container.appendChild(box);

      var inp = box.querySelector('.ai-lead-input');
      var btn = box.querySelector('.ai-lead-btn');
      function submit(e) {
        if (e) e.stopPropagation();
        var phone = (inp.value || '').trim();
        if (phone.replace(/\D/g, '').length < 9) {
          inp.focus(); inp.style.borderColor = '#e74c3c'; inp.setAttribute('aria-invalid', 'true');
          box.querySelector('.ai-lead-err').hidden = false;
          return;
        }
        box.innerHTML = '<div class="ai-lead-title">תודה! ניצור איתכם קשר בהקדם ✅</div>';
        submitLead(phone); // שליחה שקטה — תופס ליד (מייל + שמירה) בלי ליצור הודעה בצ'אט
      }
      btn.addEventListener('click', submit);
      inp.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); submit(e); } });
      inp.addEventListener('click', function(e){ e.stopPropagation(); }); // לא לסגור את החלון בלחיצה על השדה
    }

    /* שולח את הטלפון לשרת ברקע כדי שיזוהה כליד (detectPhone → leads.jsonl + מייל),
       בלי לרנדר בועת-הודעה ובלי תשובת בוט. best-effort — לא חוסם ולא זורק. */
    function submitLead(phone) {
      try {
        fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: getSessionId(),
            message: phone,
            conversationHistory: buildServerHistory()
          })
        }).catch(function(){});
      } catch (e) {}
    }

    /* "PCIe&#174;" in a catalog title → "PCIe®" (escapeHtml would print the entity as text) */
    function decodeEntities(str) {
      var t = document.createElement('textarea');
      t.innerHTML = String(str);
      return t.value;
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* =============================================
       רינדור הודעות
    ============================================= */
    function renderMessage(msgObj) {
      var div = document.createElement('div');
      div.className = 'chat-row ' + msgObj.type;

      if (msgObj.type === 'chat-user') {
        div.textContent = msgObj.text || '';
      } else if (msgObj.html) {
        div.innerHTML = msgObj.html;
      } else {
        div.textContent = msgObj.text || '';
      }

      resultsEl.appendChild(div);
      return div;
    }

    function renderLoading() {
      var div = document.createElement('div');
      div.className = 'chat-row chat-bot';
      div.setAttribute('aria-label', 'טוען...');
      div.innerHTML = '<span class="ai-typing" aria-hidden="true"><span></span><span></span><span></span></span>';
      resultsEl.appendChild(div);
      scrollToBottom();
      return div;
    }

    function renderErrorMessage(originalQuery) {
      var div = document.createElement('div');
      div.className = 'chat-row chat-error';

      var msg = document.createElement('span');
      msg.textContent = 'לא הצלחנו לקבל תשובה. אנא נסה שנית.';

      var btn = document.createElement('button');
      btn.className = 'chat-retry-btn';
      btn.textContent = 'נסה שוב';
      btn.onclick = function() {
        removeEl(div);
        window.sendMsg(originalQuery);
      };

      div.appendChild(msg);
      div.appendChild(btn);
      resultsEl.appendChild(div);
      scrollToBottom();
    }

    function removeEl(el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }

    /* =============================================
       ניהול היסטוריה
    ============================================= */
    function loadHistory() {
      try {
        var stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          chatHistory = JSON.parse(stored) || [];
          chatHistory.forEach(function(msg) { renderMessage(msg); });
          hydrateImages(resultsEl); // תמונות מוצר לכרטיסים שנטענו מההיסטוריה
        }
      } catch(e) {
        chatHistory = [];
      }
    }

    function saveToHistory(msgObj) {
      chatHistory.push(msgObj);
      if (chatHistory.length > 20) chatHistory = chatHistory.slice(-20);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(chatHistory));
      } catch(e) {}
    }

    function buildServerHistory() {
      var last = chatHistory.slice(-10);
      return last.map(function(msg) {
        return {
          role: msg.type === 'chat-user' ? 'customer' : 'bot',
          content: msg.text || (msg.html && msg.html.replace(/<[^>]*>/g, '')) || ''
        };
      });
    }

    /* =============================================
       עזרים
    ============================================= */
    function setSending(val) {
      isSending = val;
      submitBtn.disabled = val;
      submitBtn.setAttribute('aria-busy', val ? 'true' : 'false');
    }

    function scrollToBottom() {
      resultsEl.scrollTop = resultsEl.scrollHeight;
    }

    /* הפעלה */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

  })();
  
